import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { resolveBrand } from '@/utils/brandResolver';

export interface Testimonial {
  id: string;
  name: string;
  content: string;
  rating: number;
  created_at: string;
}

export const useTestimonials = (pageId?: string | null, limit?: number) => {
  const brandKey = resolveBrand();

  return useQuery({
    queryKey: ['testimonials', brandKey, pageId, limit],
    queryFn: async () => {
      let query = supabase
        .from('testimonials')
        .select('*')
        .eq('brand_key', brandKey)
        .order('created_at', { ascending: false });

      if (pageId) {
        query = query.eq('page_id', pageId);
      }

      if (limit) {
        query = query.limit(limit);
      }

      const { data, error } = await query;

      if (error) throw error;
      return data as Testimonial[];
    },
  });
};
